import React, { useEffect, useState } from 'react';
import Box from '@amzn/awsui-components-core/box';
import { SLACK_ICON_URL } from 'src/constants/AppConstants';
import { logger } from 'src/logger';
import { SSMService } from 'src/services/aws/SSMService';
import 'src/styles/_footer-quote.scss';

const SLACK_CHANNEL_URL_PARAM = '/das-finsuite/fe/slackChannelUrl';

export const FooterQuote: React.FC = () => {
  const [slackChannelUrl, setSlackChannelUrl] = useState<string>('');

  useEffect(() => {
    let cancelled = false;
    SSMService.retrieveParameter(SLACK_CHANNEL_URL_PARAM)
      .then((url) => {
        if (!cancelled) setSlackChannelUrl(url);
      })
      .catch((err) => {
        logger.error(`Failed to fetch Slack channel URL from SSM: ${err}`);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="footer-quote">
      <Box variant="p" fontSize="body-s" color="text-body-secondary" margin="n">
        <span className="footer-quote__text">
          <Box variant="span" fontWeight="bold">
            # FinSuite
          </Box>{' '}
          — Invented in <span className="footer-quote__city">San Francisco</span>. Designed in <span className="footer-quote__city">Seattle</span>.
          Reimagined in <span className="footer-quote__city">Bangalore</span> by AD3.
        </span>
      </Box>
      {slackChannelUrl && (
        <a
          href={slackChannelUrl}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Join #das-finsuite-interest Slack channel"
          className="footer-quote__slack-link"
        >
          <img src={SLACK_ICON_URL} alt="Slack" className="footer-quote__slack-icon" />
        </a>
      )}
    </div>
  );
};
